import * as React from 'react';
import { styled } from '../../theme';

export interface ArrowBoxWidgetProps {}

export const ArrowBoxWidget: React.FC<React.PropsWithChildren<ArrowBoxWidgetProps>> = (props) => {
  return <S.Container>{props.children}</S.Container>;
};
namespace S {
  export const Container = styled.div`
    min-width: 150px;
    min-height: 75px;
    background-color: ${(p) => p.theme.dialog.background};
    color: #fff;
    padding: 5px;
    position: relative;
    margin: 40px;
    float: left;
    margin-top: 40px;
    border-radius: 5px;
    box-shadow: 0 20px 20px rgba(0, 0, 0, 0.3);

    &:after {
      content: ' ';
      position: absolute;
      right: 10px;
      top: -15px;
      border-top: none;
      border-right: 15px solid transparent;
      border-left: 15px solid transparent;
      border-bottom: 15px solid ${(p) => p.theme.dialog.background};
    }
  `;
}
